










import {
  Component, Watch,
} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Entity from '@/views/Entity.vue';
import UserMixin from '@/mixins/UserMixin';
import { State } from 'vuex-class';

@Component({
  components: {
    Entity,
  },
})
export default class EntityLoader extends mixins(UserMixin) {
  defaultEntityComponent = () => import('@/views/Entity.vue');

  listedEntityComponents = () => import('@/views/entities');

  currentComponent: any = null;

  @State('pages', { namespace: 'profile' })
  pages!: any[];

  get entity(): string {
    return this.$route.params.entityName;
  }

  async beforeMount() {
    await this.renderComponent();
  }

  async renderComponent() {
    const module = await this.listedEntityComponents();
    // @ts-expect-error
    const comp: any = module[this.entity];
    if (comp) {
      this.currentComponent = comp;
    } else if (this.pages.some((page) => page.to.params && this.$route.params.entityName === page.to.params.entityName)) {
      this.currentComponent = this.defaultEntityComponent;
    } else {
      await this.$router.replace({ name: 'Error' });
    }
  }

  @Watch('entity', { immediate: true })
  async onEntityChange(value: string, oldValue: string) {
    if (value !== oldValue) {
      await this.renderComponent();
    }
  }
}

